/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material";
import { useAtomValue } from "jotai";
import { CanEscapeRefStore } from "../stores/app";
import citizenTheme from "../styles/citizenTheme";

const QuestionnaireLoadingContainer = styled("div")({
  position: "fixed",
  bottom: 4,
  right: 4,
  backgroundColor: citizenTheme.palette.primary.main,
  borderRadius: 30,
  transition: "all 300ms ease-in-out",
  padding: "8px 16px",
  display: "inline-flex",
  alignItems: "center",
  pointerEvents: "none",
});

const DOT_SIZE = 10;

const QuestionnaireLoadingElement = styled(Box)({
  position: "relative",
  width: DOT_SIZE,
  height: DOT_SIZE,
  borderRadius: DOT_SIZE * 2,
  marginRight: 12,
  backgroundColor: citizenTheme.palette.secondary.main,
  animationName: "little-glow",
  animationDuration: "2s",
  animationFillMode: "both",
  animationIterationCount: "infinite",
  animationTimingFunction: "linear",
  ":before": {
    content: '""',
    backgroundColor: alpha(citizenTheme.palette.secondary.main, 0.2),
    width: DOT_SIZE * 1.4,
    height: DOT_SIZE * 1.4,
    position: "absolute",
    top: -2,
    left: -2,
    borderRadius: DOT_SIZE * 2,
    animationName: "glow",
    animationDuration: "2s",
    animationFillMode: "both",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  },
  "@keyframes glow": {
    "0%": {
      transform: "scale(0)",
    },
    "50%": {
      transform: "scale(1.5)",
    },
    "100%": {
      transform: "scale(0)",
    },
  },
  "@keyframes little-glow": {
    "0%": {
      transform: "scale(0.8)",
    },
    "50%": {
      transform: "scale(1.2)",
    },
    "100%": {
      transform: "scale(0.8)",
    },
  },
});

function QuestionnaireLoading(): JSX.Element {
  const loading = useAtomValue(CanEscapeRefStore);

  return (
    <QuestionnaireLoadingContainer
      css={{
        transform: `translateY(${loading ? 0 : 50}px)`,
      }}
    >
      <QuestionnaireLoadingElement />
      <Typography css={{ color: "white" }}>Salvataggio</Typography>
    </QuestionnaireLoadingContainer>
  );
}

export default QuestionnaireLoading;
